<section>
  <div class="d-flex flex-row">
    <div class="mt-5 mx-auto">
      <div class="card bg-dark text-white" style="width: 18rem">
        <div class="card-body">
          <h5 class="card-title">Enter OTP</h5>
          <h6 class="card-subtitle mb-2 text-muted">
            OTP send is valid for 3 minutes only
          </h6>
          <form
            [formGroup]="otpForm"
            action="submit"
            (ngSubmit)="onSubmitForm()"
          >
            <div class="form-group">
              <input
                class="form-control my-2"
                type="text"
                formControlName="otp"
              />
            </div>

            <button
              [disabled]="otpForm.invalid"
              type="submit"
              class="btn btn-success btn-sm"
            >
              Submit OTP
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
